if (typeof customElements.get('shipping-countdown') === 'undefined') {

	class ShippingCountdown extends HTMLElement {

		connectedCallback() {
			this.textEl = this.querySelector('[data-shipping-countdown-text]');
			if (!this.textEl) return;

			this.cutoff = this.dataset.cutoff || '14:00';
			this.shippingDays = (this.dataset.shippingDays || '1,2,3,4,5')
				.split(',')
				.map(Number)
				.filter(day => !Number.isNaN(day));
			this.inStock = this.dataset.inStock === 'true';

			// "data-now" is the shop's local time at render time (Shopify's `now` /
			// `date` filters render in the shop's timezone). Everything after that
			// ticks forward using the visitor's own clock deltas.
			this.serverNow = new Date(this.dataset.now);
			this.loadedAt = Date.now();

			this._render();
			this._interval = setInterval(() => this._render(), 30000);
		}

		disconnectedCallback() {
			clearInterval(this._interval);
		}

		_getShopTime() {
			const elapsed = Date.now() - this.loadedAt;
			return new Date(this.serverNow.getTime() + elapsed);
		}

		_getCutoffOn(date) {
			const [hours, minutes] = this.cutoff.split(':').map(Number);
			const cutoff = new Date(date);
			cutoff.setHours(hours || 0, minutes || 0, 0, 0);
			return cutoff;
		}

		_nextShippingDayName(fromDate) {
			const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
			const cursor = new Date(fromDate);
			for (let i = 0; i < 7; i++) {
				cursor.setDate(cursor.getDate() + 1);
				if (this.shippingDays.includes(cursor.getDay())) {
					return dayNames[cursor.getDay()];
				}
			}
			return dayNames[fromDate.getDay()];
		}

		_formatDuration(ms) {
			const totalMinutes = Math.max(1, Math.round(ms / 60000));
			const hours = Math.floor(totalMinutes / 60);
			const minutes = totalMinutes % 60;
			if (hours > 0) {
				return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
			}
			return `${minutes}m`;
		}

		_render() {
			const now = this._getShopTime();
			const isShippingDay = this.shippingDays.includes(now.getDay());
			const cutoffToday = this._getCutoffOn(now);

			let message;
			if (isShippingDay && now < cutoffToday) {
				message = `Order in the next ${this._formatDuration(cutoffToday - now)} to ship today`;
			} else {
				message = `Order now to ship ${this._nextShippingDayName(now)}`;
			}

			const stockText = this.inStock ? 'In stock' : 'Out of stock';
			this.textEl.textContent = `${message}  –  ${stockText}`;
		}

	}

	customElements.define('shipping-countdown', ShippingCountdown);
}
